import React from 'react'
import { useIsMobile } from 'spa/member/hooks/v2/useIsMobile'
import { Card } from 'spa/member/components/Card'
import { BlockContainer } from 'spa/member/components/Top/BlockContainer'
import { HelpfulInformationCard } from 'spa/member/components/Top/HelpfulInformationCard'
import styles from './HelpfulInformation.module.scss'
import helpfulInfoArticle01 from 'images/top/helpful_info_article_01.svg'
import helpfulInfoArticle02 from 'images/top/helpful_info_article_02.svg'
import helpfulInfoArticle03 from 'images/top/helpful_info_article_03.svg'
import { responsiveValue } from 'spa/libs/utils/responsiveValue'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { breakpointsV2 } from 'spa/config/styled'

export const StyledHelpfulInformation: React.FC = () => {
  const windowWidth = useWindowWidth()
  const isMobile = useIsMobile()
  const isDesktop = windowWidth >= breakpointsV2.desktop

  const sectionDescription = () => {
    return responsiveValue(
      isMobile,
      ['クラウドワークス テックを', '利用いただいたフリーランスの方に', '参画している仕事や働き方など', 'インタビューしました。'],
      ['クラウドワークス テックを利用いただいたフリーランスの方に', '参画している仕事や働き方などインタビューしました。']
    )
  }

  return (
    <BlockContainer title='お役立ち情報' text={sectionDescription()} className='w-full'>
      <section
        className={`
          flex flex-col w-full items-center gap-S tablet:gap-XL
        `}
      >
        <section
          className={`
            flex justify-center w-full ${responsiveValue(isMobile, 'gap-S', 'gap-XL')} ${styles.cardContainer}
          `}
          style={{
            flexDirection: responsiveValue(isMobile, 'column', 'row'),
            alignItems: responsiveValue(isMobile, 'center', 'normal'),
          }}
        >
          <a href='https://crowdworks.jp/p-journal/archives/3575/' id="ga-top-pickup-saito">
            <Card
              size='default'
              device={responsiveValue(isMobile, 'SP', 'PC')}
              heading='フリーランスになってもスタンスは会社員時代と全く変わりません'
              image={helpfulInfoArticle01}
              style={{ height: isMobile ? 'auto' : isDesktop ? '274.5px' : '261px' }}
            />
          </a>
          <a href='https://crowdworks.jp/p-journal/archives/3578/' id="ga-top-pickup-shogen">
            <Card
              size='default'
              device={responsiveValue(isMobile, 'SP', 'PC')}
              heading='「社内政治」にうんざり！技術に携わりたい開発者が、フリーランスになることを決意した理由とは'
              image={helpfulInfoArticle02}
              style={{ height: isMobile ? 'auto' : isDesktop ? '274.5px' : '261px' }}
            />
          </a>
          <a href='https://crowdworks.jp/p-journal/archives/3584/' id="ga-top-pickup-sato">
            <Card
              size='default'
              device={responsiveValue(isMobile, 'SP', 'PC')}
              heading='ファッション業界からWebデザイナーへ華麗なる転身！「お金と責任」を考え、永遠にフリーランスでいたい！'
              image={helpfulInfoArticle03}
              style={{ height: isMobile ? 'auto' : isDesktop ? '274.5px' : '261px' }}
            />
          </a>
        </section>
        <section
          className={`
            flex justify-center items-center w-full all:flex-wrap desktop:flex-nowrap ${responsiveValue(isMobile, 'gap-S', 'gap-XL')}
          `}
          style={{
            flexDirection: responsiveValue(isMobile, 'column', 'row'),
          }}
        >
          <HelpfulInformationCard />
        </section>

      </section>
    </BlockContainer>
  )
}
